import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { BodyModal } from './styled.jsx';
import Header from '../header/index.jsx';
import { MessageContent } from '../error/messageContent.jsx';
import { Actions } from '../error/actions.jsx';
import ErrorIcon from '../../assets/error-icon.svg';
import { getTransactionInfo } from '../../utils/sessionStorage';
import { useTheme } from '@emotion/react';
import { getPlaidNuveiLogo } from '../../utils/common.js';


export const Modal = ({ message = '', subMessage = '', visible = false, description = '',
                        buttonLabel = null,
                        isFullScreen = false, onClickClose = null, onClickBack = null,
                        className = null}) => {
  const [classDefine, setClassDefine] = useState('');
  const theme = useTheme();

  useEffect(() => {
    // visible change -> add class animation in/out
    // [in -> show it + effect animation, out -> hide it + effect animation ]
    if (visible) setClassDefine('in');
    if (classDefine === 'in' && !visible) setClassDefine('in out');
  }, [classDefine, visible]);

  useEffect(() => {
    // Hide background inside content modal
    if (classDefine === 'in out') {
      const timeOut = setTimeout(() => {
        setClassDefine('');
      }, 500);
      return () => clearTimeout(timeOut);
    }
  }, [classDefine]);

  const obvInfo = getTransactionInfo();

  return (
    <BodyModal customStyle={{ fullScreen: isFullScreen }}>
      <div className={`popup-box ${className} ${classDefine}`}>
        <div className='box'>
          <Header
            logoUrl={getPlaidNuveiLogo(theme)}
            onClickClose={onClickClose}
          />
          <MessageContent
            visible={visible}
            imageUrl={ErrorIcon}
            message={message}
            subMessage={subMessage}
            description={description}
          />
          <Actions
            buttonLabel={buttonLabel}
            backMerchant={onClickBack}
            merchant={obvInfo ? obvInfo.merchantName : null}
            theme={theme}
          />
        </div>
      </div>
    </BodyModal>
  );
};

Modal.propTypes = {
  /**
   * Message error
   */
  message: PropTypes.string,
  /**
   * Sub message error
   */
  subMessage: PropTypes.string,
  /**
   * Description message error
   */
  description: PropTypes.string,
  /**
   * The label message to override `Back to Merchant` message
   */
  buttonLabel: PropTypes.string,
  /**
   * Show/Hide popup
   */
  visible: PropTypes.bool,
  /**
   * You can choose full screen or not
   */
  isFullScreen: PropTypes.bool,
  /**
   * Define function outside component
   */
  onClickClose: PropTypes.func,
  /**
   * Define function outside component
   */
  onClickBack: PropTypes.func,
  /**
   * What className to use for popup-box
   */
  className: PropTypes.string,

  afterFinish: PropTypes.func
};
